import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  AlertDialogComponent,
  ConfirmDialogComponent,
  ErrorDialogComponent,
  ErrorHttpDialogComponent,
  SuccessDialogComponent,
} from '../notification';

@NgModule({
  declarations: [
    AlertDialogComponent,
    ConfirmDialogComponent,
    SuccessDialogComponent,
    ErrorDialogComponent,
    ErrorHttpDialogComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild({ isolate: false }),
  ],
  exports: [AlertDialogComponent, ConfirmDialogComponent],
})
export class NotificationModule {}
